// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var QuickTableComparingType;
(function (QuickTableComparingType) {
    QuickTableComparingType[QuickTableComparingType["String"] = 0] = "String";
    QuickTableComparingType[QuickTableComparingType["Int"] = 1] = "Int";
    QuickTableComparingType[QuickTableComparingType["Double"] = 2] = "Double";
    QuickTableComparingType[QuickTableComparingType["Long"] = 3] = "Long";
    QuickTableComparingType[QuickTableComparingType["DateTime"] = 4] = "DateTime";
})(QuickTableComparingType || (QuickTableComparingType = {}));
